import { makeStyles } from '@mui/styles';
import { Colors } from '../../../layout/theme-next';
import { NextTheme } from '../../../layout/theme-next/provider';

export const useStyles = makeStyles<NextTheme>((theme) => ({
  starIcon: {
    color: Colors.primary,
    height: 16,
    width: 16,
    marginRight: theme.spacing(2),
  },
}));
